// extracted by mini-css-extract-plugin
export default {"summary":"ColumnBreak_summary__EvcpF","title":"ColumnBreak_title__nQ6Xs","delete":"ColumnBreak_delete__cXQEo","handle":"ColumnBreak_handle__XZqLT"};